<template>
  <p v-if="fieldPath && errors[fieldPath]" class="text-sm text-red-600">{{ errors[fieldPath] }}</p>
  <p v-if="fieldPath && isComplexRelationship && errors[computedFieldPath]" class="text-sm text-red-600">{{ errors[computedFieldPath] }}</p>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps(["fieldPath", "errors"]);

const isComplexRelationship = computed(() => {
  return props.fieldPath.startsWith("relationships") && props.fieldPath.endsWith(".data");
});

const computedFieldPath = computed(() => {
  if (isComplexRelationship.value) {
    return props.fieldPath.concat(".id");
  } else {
    return props.fieldPath;
  }
});

</script>
